import React, { useContext, useEffect, useRef } from 'react';
import { format, startOfMonth, parseISO } from 'date-fns';

import { CalendarContext } from '../../context/CalendarContext.jsx';
import CalendarBlock from '../../../../calendar-block/CalendarBlock.jsx';
import CalendarBlockNoResults from '../../../../calendar-block/CalendarBlocksNoResults.jsx';

function FetchNextMonthTrigger() {
  const { fetchNextMonth, fetchedTo, filter } = useContext(CalendarContext);

  const ref = useRef(null);
  const id = format(startOfMonth(fetchedTo, 1), 'MM/dd/yy');

  const observer = useRef(null);

  useEffect(() => {
    if (ref.current) {
      observer.current = new IntersectionObserver(
        async ([entry], obs) => {
          if (entry.isIntersecting) {
            await fetchNextMonth();
            obs.unobserve(entry.target);
          }
        },
        { threshold: 1 }
      );

      observer.current.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.current.unobserve(ref.current);
      }

      observer.current.disconnect();
    };
  }, [ref, filter]);

  return <div id={id} ref={ref} />;
}

function CalendarResults() {
  const { results, config, isLastPage, hasDateRange, isFetching, isLoading, fetchedTo, contentRef } = useContext(CalendarContext);
  let currentMonth = null;
  return (
    <div className="calendar__results-wrapper">
      <div className="calendar__results" aria-live="polite" aria-busy={isLoading ? 'true' : 'false'} ref={contentRef}>
        {results && results.length > 0 && (
          <>
            {results.map((result) => {
              const month = format(startOfMonth(parseISO(result.date)), 'MM/dd/yy');
              const isNextMonth = month !== currentMonth;
              currentMonth = month;

              return (
                <CalendarBlock
                  key={result.date}
                  month={month}
                  id={isNextMonth ? month : undefined}
                  headline={result.headline}
                  topline={result.topline}
                  items={result.items}
                />
              );
            })}

            {!isLastPage && !isFetching && !hasDateRange && config.dateSwitch.type === 'preview' && <FetchNextMonthTrigger key={fetchedTo} />}
          </>
        )}

        {isFetching && (
          <div className="calendar__fetching">
            <div className="spinner">
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        )}

        {!isFetching && !hasDateRange && config.dateSwitch.type === 'preview' && isLastPage && (
          <CalendarBlockNoResults label={config.labels.noResultsRemaining} />
        )}

        {results.length === 0 && <CalendarBlockNoResults label={config.labels.noResults} />}
      </div>

      <div className="spinner calendar__loading">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

export default CalendarResults;
